import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useStore from "../../store";
import withAuth from "../Auth/withAuth";

function QuestionBank() {
  const navigate = useNavigate();

  const { logout, setPageTitle, tenantId, isLoggedIn, data } = useStore(
    (state) => state
  );

  useEffect(() => {
    setPageTitle("Smart i-Questions");
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      logout();
      navigate(`/?tenantId=${tenantId}`);
    }
  }, []);

  return (
    <div>
      <iframe
        title="my-iframe"
        width="100%"
        height="1000px"
        src={`https://ipsznc.scube-edutech.com?category=Q&id_token=${data.idToken.jwtToken}&access_token=${data.accessToken.jwtToken}&tenant_id=${tenantId}`}
      ></iframe>
    </div>
  );
}

export default withAuth(QuestionBank);
